import { MouseEvent } from 'react'

import styled, { css } from 'styled-components'

import { MAX_SIZE_PHOTO_VIEWER_MOBILE } from 'common/constants'
import { backgroundTransparentDefault } from 'common-constants/colors'
import { ModalCss } from 'components/layout/ModalLayout/ModalLayout.styled'
import { Sizes } from 'components/layout/Sizes'
import { SizeProps } from 'components/page/PhotoViewer/PhotoViewer.types'
import { media } from 'components/presentational'

export const PhotoViewerWrapper = styled.div<{
  size: SizeProps
}>`
  display: flex;
  flex-direction: row;
  position: relative;
  height: ${(props) => (props.size.height ? `${props.size.height}px` : '80vh')};
  width: ${(props) => (props.size.width ? `${props.size.width}px` : '80vw')};
  max-width: 1150px;
  min-height: 400px;
  min-width: 400px;
  overflow: hidden;
  background-color: var(--static-black);
  flex-grow: 1;
  border-radius: 10px;
  align-items: center;

  &:hover [data-name='arrow-left'],
  &:hover [data-name='arrow-right'] {
    opacity: 1;
  }

  ${media.tablet`       
    width: ${MAX_SIZE_PHOTO_VIEWER_MOBILE};
    height: auto;
    min-height: auto;    
    min-width: inherit;   
    border-radius: 0;        
    flex-grow: 1;    
  `};
`

export const PhotoViewerContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  flex-grow: 1;
  margin: 0;
  will-change: transform;
  position: absolute;
  inset: 0;
`

export const PhotoWrapper = styled.div<{
  $isShadowUpperPhoto: boolean
  onClick?: ((event: MouseEvent<HTMLDivElement>) => void) | undefined
}>`
  display: flex;
  position: relative;
  flex-shrink: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  ${({ onClick }) => onClick && 'pointer-events: all;'};

  &::after {
    display: ${(props) => (props.$isShadowUpperPhoto ? 'block' : 'none')};
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${backgroundTransparentDefault};
  }
`

const imageBaseCss = css`
  width: 100%;
  height: 100%;
  will-change: transform;
  object-fit: contain;
`

export const Picture = styled.picture`
  display: block;
  width: 100%;
  height: 100%;
  will-change: transform;
`

export const Source = styled.source`
  ${imageBaseCss}
`

export const Image = styled.img`
  ${imageBaseCss}
`

export const PhotoViewerModal = styled.div`
  ${ModalCss};
  margin: auto 0;
  user-select: none;
  background-color: transparent;
  border-radius: 0;
  box-shadow: none;

  ${media.tablet`  
    height: ${Sizes.customFullHeight};
    
    width: 100%;     
    flex-grow: 1;    
    margin: 0;
  `};
`

export const PhotoViewerNoticeContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 100%;
  background-color: rgba(var(--static-black-rgb), 0.7);
  padding: 10px;
  box-sizing: border-box;
`

export const ContainerCenter = styled.div`
  display: grid;
  position: fixed;
  height: 100%;
  width: 100%;
  place-items: center;
  background-color: rgba(var(--static-black-rgb), 0.65);
  color: var(--static-white);
`
